import * as types from '../types/analyticsTypes';

const initialState = {
  overview: null,
  salesChart: [],
  ordersChart: [],
  revenueByStore: [],
  loading: false,
  error: null,
};

function analyticsReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_OVERVIEW_REQUEST:
    case types.FETCH_SALES_CHART_REQUEST:
    case types.FETCH_ORDERS_CHART_REQUEST:
    case types.FETCH_REVENUE_BY_STORE_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_OVERVIEW_SUCCESS:
      return { ...state, loading: false, overview: action.payload };
    case types.FETCH_SALES_CHART_SUCCESS:
      return { ...state, loading: false, salesChart: action.payload };
    case types.FETCH_ORDERS_CHART_SUCCESS:
      return { ...state, loading: false, ordersChart: action.payload };
    case types.FETCH_REVENUE_BY_STORE_SUCCESS:
      return { ...state, loading: false, revenueByStore: action.payload };
    case types.FETCH_OVERVIEW_FAILURE:
    case types.FETCH_SALES_CHART_FAILURE:
    case types.FETCH_ORDERS_CHART_FAILURE:
    case types.FETCH_REVENUE_BY_STORE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default analyticsReducer;
